
import { Search, FileText, Camera, CheckCircle, Users, Car } from 'lucide-react';
import { getLanguage } from '@/utils/languageUtils';
import svCommon from '@/i18n/locales/sv/common.json';
import enCommon from '@/i18n/locales/en/common.json';

const getProcessSteps = () => {
  const lang = getLanguage();
  const common = lang === 'en' ? enCommon : svCommon;
  const stepsData = common.menuPages?.sellCar?.processSteps?.steps || [];
  
  const icons = [Search, FileText, Camera, Users, CheckCircle, Car];
  const numbers = ["01", "02", "03", "04", "05", "06"];

  return stepsData.map((step: any, index: number) => {
    const Icon = icons[index] || icons[0];
    return {
      number: numbers[index] || String(index + 1).padStart(2, '0'),
      icon: Icon,
      title: step.title || "",
      description: step.description || "",
      details: step.details || []
    };
  });
};

export const processSteps = getProcessSteps();
